const langInvestFundPerformancesPrivateCreditLang = {
	title_capital: {
		tag: 'invest.fund_performances_private_credit.title_capital',
		fr: 'CAPITAL',
		en: 'CAPITAL',
	},
	text_your_position: {
		tag: 'invest.fund_performances_private_credit.text_your_position',
		fr: 'Votre position',
		en: 'Your position',
	},
	text_fund_total: {
		tag: 'invest.fund_performances_private_credit.text_fund_total',
		fr: 'Total du fonds',
		en: 'Funds total',
	},
	committed_capital: {
		tag: 'invest.fund_performances_private_credit.committed_capital',
		fr: 'Capital engagé',
		en: 'Committed capital',
	},
	called_capital: {
		tag: 'invest.fund_performances_private_credit.called_capital',
		fr: 'Capital appelé',
		en: 'Called capital',
	},
	callable_capital: {
		tag: 'invest.fund_performances_private_credit.callable_capital',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},

	total_distributed: {
		tag: 'invest.fund_performances_private_credit.total_distributed',
		fr: 'Distribués',
		en: 'Distributed',
	},
	interest_income: {
		tag: 'invest.fund_performances_private_credit.interest_income',
		fr: 'Intérêts',
		en: 'Interest income',
	},
	return_of_capital: {
		tag: 'invest.fund_performances_private_credit.return_of_capital',
		fr: 'Amortissements',
		en: 'Return of capital',
	},
	net_called_capital: {
		tag: 'invest.fund_performances_private_credit.net_called_capital',
		fr: 'Capital net',
		en: 'Capital at work',
	},
	asset_outstanding_capital: {
		tag: 'invest.fund_performances_private_credit.asset_outstanding_capital',
		fr: 'Capital restant dû',
		en: 'Outstanding capital',
	},
	asset_outstanding_capital_sub_label: {
		tag: 'invest.fund_performances_private_credit.asset_outstanding_capital_sub_label',
		fr: 'CRD',
		en: '',
	},
	asset_outstanding_capital_tooltip: {
		tag: 'invest.fund_performances_private_credit.asset_outstanding_capital_tooltip',
		fr: 'Capital restant dû : Capital que les sous-jacents (actif) doivent encore rembourser au fonds',
		en: 'Outstanding capital (the asset outstanding capital): total amount still owed by a fund assets to the fund',
	},

	title_performance: {
		tag: 'invest.fund_performances_private_credit.title_performance',
		fr: 'PERFORMANCE',
		en: 'PERFORMANCE',
	},
	nav: {
		tag: 'invest.fund_performances_private_credit.nav',
		fr: 'NAV',
		en: 'NAV',
	},
	irr: {
		tag: 'invest.fund_performances_private_credit.irr',
		fr: 'TRI',
		en: 'IRR',
	},
	arr: {
		tag: 'invest.fund_performances_private_credit.arr',
		fr: 'ARR',
		en: 'ARR',
	},
	total_value: {
		tag: 'invest.fund_performances_private_credit.total_value',
		fr: 'Valeur totale',
		en: 'Total value',
	},

	tvpi: {
		tag: 'invest.fund_performances_private_credit.tvpi',
		fr: 'TVPI',
		en: 'TVPI',
	},

	dpi: {
		tag: 'invest.fund_performances_private_credit.dpi',
		fr: 'DPI',
		en: 'DPI',
	},
	rvpi: {
		tag: 'invest.fund_performances_private_credit.rvpi',
		fr: 'RVPI',
		en: 'RVPI',
	},
};

export default langInvestFundPerformancesPrivateCreditLang;
